
class EnvHelper {
    public static isDevelopmentQa = () : boolean => {
        return ENV_NAME === 'qa';
    }

    public static getEnvName = () : string => {
        if (ENV_NAME === 'production') {
            return 'ZZ2 E-WAGES';
        } else if (ENV_NAME === 'qa') {
            return 'ZZ2 E-WAGES QA';
        } else if (ENV_NAME === 'dev') {
            return 'ZZ2 E-WAGES DEV';
        } else {
            return 'ZZ2 E-WAGES ENV NOT FOUND';
        }
    };
}

export default EnvHelper;